import WithdrawalModal from './WithdrawalModal'

export default WithdrawalModal